import { render, staticRenderFns } from "./SectionNewTickets.vue?vue&type=template&id=9d8c47ea&scoped=true&"
import script from "./SectionNewTickets.vue?vue&type=script&lang=js&"
export * from "./SectionNewTickets.vue?vue&type=script&lang=js&"
import style0 from "./SectionNewTickets.vue?vue&type=style&index=0&id=9d8c47ea&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8c47ea",
  null
  
)

export default component.exports